import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {HttpClient} from '@angular/common/http';
import {environment} from '../../environments/environment';
import { Student } from '../models/student';
@Injectable({
  providedIn: 'root'
})
export class StudentService {

  constructor(private readonly http: HttpClient) {
  }

  create(student: Student ): Promise<Student> {
    return this.http.post<Student>(
      `${environment.apiEndpoint}api/v1/student`,
      student,
      {responseType: 'json', observe: 'body'}
    ).toPromise();
  }

  getStudent(phone: string): Promise<Student> {
    return this.http.get<Student>(`${environment.apiEndpoint}api/v1/student/${phone}`).toPromise();
  }

  update(student: Student): Promise<Student> {
    return this.http.post<Student>(
      `${environment.apiEndpoint}api/v1/student/${student._id}`, student,
      {responseType: 'json', observe: 'body'}
    ).toPromise();
  }

  delete(id: string) {
    return this.http.delete<Student>(`${environment.apiEndpoint}api/v1/student/${id}`).toPromise();
  }
}
